module.exports = __webpack_public_path__ + "img/insta-3.62ac96a1.jpg";